import { LinkedInIcon, TwitterIcon, YoutubeIcon } from "components/Icons";
import { ClariahLink } from "components/ClariahLink";
import { LARGE, HOMEPAGE_TYPE } from "shared/constants";
import { Logo } from "components/Logo";
import { MaxWidth } from "components/MaxWidth";
import { useRouter } from "next/router";
import { VisuallyHiddenText } from "components/VisuallyHiddenText";
import cx from "classnames";
import styles from "./Footer.module.css";

const socialLinks = [
  {
    href: "https://www.linkedin.com/search/results/all/?keywords=CLARIAH",
    icon: <LinkedInIcon />,
    label: "LinkedIn",
  },
  {
    href: "https://twitter.com/clariah_nl",
    icon: <TwitterIcon />,
    label: "Twitter",
  },
  {
    href: "https://www.youtube.com/channel/UCcyiTzbvt2vXna9DwwIjFkQ",
    icon: <YoutubeIcon />,
    label: "Youtube",
  },
];

export const Footer = ({ footer, withBorder }) => {
  const { menus, footerMenu } = footer || {};

  return (
    <footer className={cx(styles.footer, { [styles.withBorder]: withBorder })}>
      <MaxWidth size={LARGE}>
        <div
          className={cx(styles.menuFooterContainer, {
            [styles.withBorder]: withBorder,
          })}
        >
          <div className={styles.menuFooter}>
            <div className={styles.logoContainer}>
              <ClariahLink
                className={styles.logoLink}
                type={HOMEPAGE_TYPE}
                href="/"
                title="Homepage"
              >
                <Logo />
              </ClariahLink>
            </div>
            {(menus || []).map(({ items, title }) => (
              <div key={title}>
                <h2 className={styles.title}>{title}</h2>
                <ul className={styles.linkList}>
                  {(items || []).map(({ label, item }, index) => (
                    <li key={index}>
                      <ClariahLink
                        href={item?.slug?.current || ""}
                        type={item?._type}
                      >
                        {label}
                      </ClariahLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </MaxWidth>
      <div className={styles.realFooterContainer}>
        <MaxWidth size={LARGE}>
          <div className={styles.realFooter}>
            <div className={styles.realFooterLinks}>
              {(footerMenu || []).map(({ label, item }, index) => (
                <ClariahLink
                  key={index}
                  href={item?.slug?.current || ""}
                  type={item?._type}
                >
                  {label}
                </ClariahLink>
              ))}
            </div>
            {/* <div className={styles.realFooterSocials}>
              {socialLinks.map(({ href, icon, label }) => (
                <ClariahLink key={href} href={href} noExternalIcon>
                  <VisuallyHiddenText>{label}</VisuallyHiddenText>
                  {icon}
                </ClariahLink>
              ))}
            </div> */}
          </div>
        </MaxWidth>
      </div>
    </footer>
  );
};
